import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core/styles';

const CampaignShine = () => {
  const theme = useTheme();

  return (
    <Box marginBottom={4}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="primary"
        align="center"
      >
        Campaña principal
      </Typography>
      <Typography variant="h4" fontWeight={700} align="center" color="primary" gutterBottom>
        El Brillo de TNO
      </Typography>

      <Box sx={{ maxWidth: 720, mx: 'auto', mb: 3 }}>
        <Typography variant="subtitle2" fontWeight={700} color="primary" gutterBottom>
          Concepto
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          <strong>TNO Network</strong> es una ventana al mundo: <strong>streaming</strong> y <strong>On-Demand</strong>{' '}
          llevan voces, historias y marcas a quienes nos escuchan y nos ven en cualquier pantalla. Para que esa ventana
          funcione, debe estar
          impecable: sin mancha en el cristal ni ruido en el mensaje. <strong>Danimar</strong> es el responsable de que
          nuestra casa —estudios, equipos y espacios— <strong>brille</strong>, para que la tuya pueda{' '}
          <strong>destacar</strong> con la misma exigencia.
        </Typography>
      </Box>

      <Box
        sx={{
          maxWidth: 720,
          mx: 'auto',
          py: 2.5,
          px: 3,
          mb: 3,
          borderRadius: 2,
          borderLeft: `4px solid ${theme.palette.primary.main}`,
          bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
        }}
      >
        <Typography variant="subtitle2" fontWeight={700} color="primary" gutterBottom>
          Frase ancla
        </Typography>
        <Typography variant="h6" component="p" color="textSecondary" sx={{ fontStyle: 'italic', fontWeight: 500 }}>
          Toda gran idea brilla más sobre una superficie limpia. Danimar: el brillo oficial de TNO Network.
        </Typography>
      </Box>

      <Box sx={{ maxWidth: 720, mx: 'auto', mb: 3 }}>
        <Typography variant="subtitle2" fontWeight={700} color="primary" gutterBottom>
          Reason why
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph sx={{ mb: 0 }}>
          Si <strong>Danimar</strong> mantiene impecables estudios de alta tecnología, cámaras y cristales bajo luces de
          estudio —donde cada reflejo cuenta—, demuestra que puede con el mismo estándar en el hogar, en la industria y
          en cualquier reto de limpieza real.
        </Typography>
      </Box>

      <Box
        sx={{
          maxWidth: 720,
          mx: 'auto',
          p: 2.5,
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
          bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
        }}
      >
        <Typography variant="subtitle2" fontWeight={700} color="primary" gutterBottom>
          Contenido TNO Digest
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          <strong>En señal y redes:</strong> <strong>4 historias semanales</strong> en streaming y{' '}
          <strong>4 reels al mes</strong> que muestran la limpieza en acción en sede y estudios con Danimar —evidencia
          clara de cómo TNO mantiene el entorno listo para streaming y On-Demand.
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ mb: 0 }}>
          <strong>Artículos en TNO Digest:</strong> <strong>4 al mes, siempre</strong> —textos alineados a{' '}
          <strong>orden, limpieza, bienestar e higiene</strong> en el hogar y el entorno laboral (rutinas, ahorro,
          cuidado de superficies, hábitos saludables). SEO con intención de búsqueda real y enlaces a canales de venta
          cuando aplique.
        </Typography>
      </Box>
    </Box>
  );
};

export default CampaignShine;
